import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
        path: '/404',
        name: '404',
        redirect: '/',
        component: require('@/pages/common/404')
    },
    {
        path: '*',
        redirect: '/'
    },
    {
      path: '/',
      name: 'Index',
      component: require('@/pages/index/index.vue'),
      meta: {
        auth: true
      }
    },
    {
      path: '/oekonomi',
      name: 'Economy',
      component: require('@/pages/economy/economy.vue'),
      meta: {
        auth: true
      },
      children: [
        {
          path: 'drift',
          name: 'EconomyOperations',
          component: require('@/pages/economy/operations.vue')
        },
        {
          path: 'oekonomi',
          name: 'EconomyLearning',
          component: require('@/pages/economy/learning.vue')
        }
      ]
    },
    {
      path: '/kunder',
      name: 'Customers',
      component: require('@/pages/customers/customers.vue'),
      meta: {
        auth: true
      },
      children: [
        {
          path: 'drift',
          name: 'CustomersOperations',
          component: require('@/pages/customers/operations.vue')
        },
        {
          path: 'udvikling-og-laering',
          name: 'CustomersLearning',
          component: require('@/pages/customers/learning.vue')
        }
      ]
    },
    {
      path: '/opgaver',
      name: 'Projects',
      component: require('@/pages/projects/projects.vue'),
      meta: {
        auth: true
      },
      children: [
        {
          path: 'drift',
          name: 'ProjectsOperations',
          component: require('@/pages/projects/operations.vue')
        },
        {
          path: 'udvikling-og-laering',
          name: 'ProjectsLearning',
          component: require('@/pages/projects/learning.vue')
        }
      ]
    },
    {
      path: '/medarbejdere',
      name: 'Employees',
      component: require('@/pages/employees/employees.vue'),
      meta: {
        auth: true
      },
      children: [
        {
          path: 'drift',
          name: 'EmployeesOperations',
          component: require('@/pages/employees/operations.vue')
        },
        {
          path: 'udvikling-og-laering',
          name: 'EmployeesLearning',
          component: require('@/pages/employees/learning.vue')
        }
      ]
    },
    {
      path: '/ansvarlige',
      name: 'Responsibles',
      component: require('@/pages/responsibles/index.vue'),
      meta: {
        auth: true
      }
    },
    {
      path: '/potentiale',
      name: 'Potential',
      component: require('@/pages/potential/index.vue'),
      meta: {
        auth: true
      }
    },
    {
      path: '/register',
      name: 'Register',
      component: require('@/pages/register/register.vue'),
      meta: {
        auth: false
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: require('@/pages/login/login.vue'),
      meta: {
        auth: false
      }
    },
    {
      path: '/indstillinger',
      name: 'Settings',
      component: require('@/pages/settings/index'),
      meta: {
        auth: true
      }
    },
    {
      path: '/entreprise',
      name: 'Enterprise',
      component: require('@/pages/enterprise/index'),
      meta: {
        auth: true
      }
    },
    {
      path: 'skift-virksomhed',
      name: 'ChangeCompany',
      component: require('@/pages/settings/components/changeCompany'),
      meta: {
        auth: true
      }
    },
    {
      path: '/super-admin',
      name: 'SuperAdmin',
      component: require('@/pages/superadmin/index'),
      meta: {
        auth: true
      }
    },
    {
      path: '/kommer-snart',
      name: 'ComingSoon',
      component: require('@/pages/common/comingsoon'),
      meta: {
        auth: true
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js